import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { DISTRIBUTIONS } from 'store/form/names';
import { generateDistributionData } from 'store/scenes/distributions/actions';

import {
  getDistributionsType,
  doDistributionsFormExist
} from 'store/form/distributions/selectors';

import DistributionFormComponent from './Component';

const initialValues = {
  type: 'normal',

  denominatorDf: '10',
  numeratorDf: '5',

  dof: '10',

  stdev: '1',
  mean: '0',

  alpha: 0.05,

  numberOfTrials: 10,
  probabilityOfSuccess: 0.5,

  leftCutoff: -Infinity,
  rightCutoff: +Infinity,

  bLeftCutoff: 2,
  bRightCutoff: 3,

  leftZScore: -Infinity,
  rightZScore: -Infinity
};

class DistributionFormContainer extends React.PureComponent {
  componentDidMount () {
    if (this.props.distributionsFormExist) {
      return;
    }

    this.props.generateDistributionData(
      initialValues, { alpha: initialValues.alpha }
    );
  }

  render () {
    return <DistributionFormComponent {...this.props} />;
  }
}

DistributionFormContainer.propTypes = {
  generateDistributionData: PropTypes.func.isRequired,
  distributionsFormExist: PropTypes.bool.isRequired,

  distributionType: PropTypes.string
};

DistributionFormContainer.defaultProps = {
  distributionType: 'normal'
};

const mapStateToProps = state => ({
  distributionType: getDistributionsType(state),
  distributionsFormExist: doDistributionsFormExist(state)
});

const mapDispatchToProps = {
  generateDistributionData
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({ form: DISTRIBUTIONS, initialValues, destroyOnUnmount: false })(
    DistributionFormContainer
  )
);
